var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.pronunciation)?_c('span',{class:_vm.class_value,domProps:{"innerHTML":_vm._s(_vm.pronunciation)}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }